import React from 'react';

import styles from './Rights.module.css';

export default () => (
  <div className={styles.rights}>
    <span>
      {`\u00A9 1996 - ${new Date().getFullYear()} - UOL - O melhor conteúdo. Todos os direitos reservados.`}
    </span>
  </div>

);
